export default __webpack_public_path__ + "static/media/branch.d2b57117.svg";